import React from "react";
import { ParticipantUpdatesContainer } from "../../../containers";

const ParticipantUpdatesReport = (props) => {
  return <ParticipantUpdatesContainer {...props} />;
};

export default ParticipantUpdatesReport;
